export const GROUP_STATUS = {
  active: {
    id: 'active',
    label: {
      long: 'label.ROUTED',
      short: 'label.ROUTED'
    }
  },
  inactive: {
    id: 'inactive',
    label: {
      long: 'label.UNASSIGNED',
      short: 'label.UNASSIGNED'
    }
  }
};
